import { Wrench, PhoneCall, Star } from "lucide-react";
import { Link } from "react-router-dom";

const BG = "https://customer-assets.emergentagent.com/job_chatbot-finder-pro/artifacts/e2mzrvhm_ED1694BC-D412-4A1E-A053-5BC63B4BA064.png";

const SERVICES = [
  { name: "Insurance Repairs", desc: "We deal directly with your insurer — assessment, quoting and full repair after accident or storm damage." },
  { name: "Private Repairs", desc: "Out-of-pocket repairs of any size, from a quick fix to a full rebuild. Honest quotes, no surprises." },
  { name: "Mechanical Servicing", desc: "A full service of everything that keeps your van roadworthy — brakes, magnets, bearings, bushes, lights and indicators." },
  { name: "12V Electrical", desc: "Basic 12V electrical repairs and fault diagnosis — batteries, lighting, fittings and wiring." },
  { name: "Air Conditioner Replacement", desc: "Air-con packed it in? We don't diagnose air-con faults, but if the unit has failed we can remove the old one and fit a replacement." },
  { name: "Plumbing", desc: "Water pumps, taps, tanks and water fittings — keeping your van's water system flowing." },
  { name: "Seals Inspection", desc: "We'll check the condition of your van's seals and give you a free, no-obligation estimate for any resealing or repairs needed to keep the water out." },
];

export default function Services() {
  return (
    <main className="relative min-h-screen overflow-hidden" data-testid="services-page">
      <img
        src={BG}
        alt="Nomad caravan mechanic"
        className="absolute inset-0 w-full h-full object-cover object-[78%_center] z-0"
      />
      <div className="absolute inset-0 z-[1] bg-gradient-to-r from-black/35 via-black/10 to-transparent" />
      <section className="relative z-10 container mx-auto px-6 pt-16 pb-6">
        <div className="bg-white/55 backdrop-blur-md border border-white/60 ring-1 ring-black/5 p-6 max-w-xl shadow-2xl">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#15803D] mb-3">
            ◆ Bowen · Whitsundays · What We Do
          </div>
          <h1 className="font-display text-4xl font-black tracking-tighter text-zinc-950 leading-[0.95]">
            Services we offer.
          </h1>
          <p className="mt-3 text-sm text-zinc-800 leading-relaxed">
            From a quick fix to a full rebuild — here's what the team at Nomad Caravan Repairs handles in-house. If your job's on this list, chat with Rosie and we'll get you booked in.
          </p>
        </div>
      </section>

      <section className="relative z-10 container mx-auto px-6 pb-16">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 max-w-md xl:max-w-2xl">
          {SERVICES.map((s) => (
            <div
              key={s.name}
              data-testid={`service-${s.name.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
              className="bg-white/45 backdrop-blur-md border border-white/50 ring-1 ring-black/5 p-4 hover:bg-white/65 hover:border-[#16A34A] transition-all flex flex-col gap-1.5 shadow-xl"
            >
              <Wrench className="w-4 h-4 text-[#15803D]" />
              <h3 className="font-display font-bold text-lg text-zinc-950 leading-tight">{s.name}</h3>
              <p className="text-sm text-zinc-800 leading-snug">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-zinc-950/75 backdrop-blur-md border border-white/10 text-white p-5 max-w-md shadow-2xl">
          <h2 className="font-display font-black text-lg tracking-tight">Ready to get your van sorted?</h2>
          <p className="mt-1.5 text-zinc-200 text-sm leading-relaxed">We'll get back to you ASAP.</p>
          <Link
            to="/request"
            data-testid="services-request-btn"
            className="mt-4 inline-flex items-center gap-2 bg-[#16A34A] text-white px-5 py-2.5 font-semibold hover:bg-[#15803D] transition-colors"
          >
            <PhoneCall className="w-4 h-4" /> Request a Service or Call Back
          </Link>
        </div>

        <div className="mt-4 max-w-md">
          <aside
            data-testid="services-testimonial"
            className="w-full bg-zinc-950/65 backdrop-blur-md border border-white/15 ring-1 ring-black/20 p-5 shadow-2xl"
          >
            <div className="flex items-center gap-3">
              <img
                src="/jason-grech.png"
                alt="Jason Grech"
                className="w-12 h-12 rounded-full object-cover border border-white/25"
              />
              <div className="leading-tight">
                <div className="font-display font-bold text-white text-sm">Jason Grech</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#4ADE80]">CEO · Titanium Caravans</div>
              </div>
            </div>
            <div className="mt-3 flex gap-0.5">
              {[0,1,2,3,4].map((i) => (
                <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
              ))}
            </div>
            <div className="mt-3 space-y-2">
              <p className="text-[13px] text-white/90 leading-relaxed">Nomad Caravan Repairs are a reputable business and Titanium Caravans' preferred repairer in North Queensland.</p>
              <p className="text-[13px] text-white/90 leading-relaxed">We have known Daniel for 10 years, giving Daniel significant knowledge specifically in Titanium vans.</p>
              <p className="text-[13px] text-white/90 leading-relaxed">Titanium Caravans selects only the finest, reliable repairers with quality trades people to complete work on our premium caravans.</p>
              <p className="text-[13px] text-white/90 leading-relaxed">From service to repairs, we are confident to recommend Nomad Caravan Repairs to assist you.</p>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
